import { button, textStyles } from '@mage-ui/styled-system/recipes';
import Link from 'next/link';
import { Section } from '../../layouts/sections/Section';
export const Feedback = ({ data, language, ...props }) => {
	return (
		<Section
			heading={{
				title: data?.fields?.title,
				intro: data?.fields?.intro,
			}}
			{...props}
		>
			{data?.fields?.content && (
				<div
					className={textStyles()}
					dangerouslySetInnerHTML={{ __html: data?.fields?.content || '' }}
				/>
			)}
			{(data?.fields?.cta_text || data?.fields?.cta_link) && (
				<div>
					<Link
						href={data?.fields?.cta_link || `/${language || ''}`}
						className={button()}
					>
						{data?.fields?.cta_text}
					</Link>
				</div>
			)}
		</Section>
	);
};
